/**
 * Browser-safe NDJSON stream consumer (no Node/process deps).
 * Used by the embeddable widget and re-exported from streamNdjson.js.
 */
export async function consumeChatNdjsonStream(response, handlers = {}) {
  const {
    onDelta,
    onDone,
    onError,
    onPipelineTrace,
    onModuleUi,
    onUiPart,
    onUiPatch,
    onToolCall,
    onToolResult,
  } = handlers;

  if (!response.body) {
    onError?.({ message: 'No response body' });
    return;
  }
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buf = '';
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const lines = buf.split('\n');
    buf = lines.pop() ?? '';
    for (const line of lines) {
      if (!line.trim()) continue;
      let obj;
      try {
        obj = JSON.parse(line);
      } catch {
        continue;
      }
      dispatchNdjsonEvent(obj, handlers);
    }
  }
  if (buf.trim()) {
    let obj;
    try {
      obj = JSON.parse(buf);
    } catch {
      return;
    }
    dispatchNdjsonEvent(obj, handlers);
  }
}

function dispatchNdjsonEvent(obj, handlers) {
  const {
    onDelta,
    onDone,
    onError,
    onPipelineTrace,
    onModuleUi,
    onUiPart,
    onUiPatch,
    onToolCall,
    onToolResult,
    onRouterStatus,
  } = handlers;

  if (obj.type === 'delta' && obj.content) {
    onDelta?.(obj.content);
  } else if (obj.type === 'pipeline_trace' && obj.pipeline_trace != null) {
    onPipelineTrace?.(obj.pipeline_trace);
  } else if (obj.type === 'module_ui') {
    onModuleUi?.(obj);
  } else if (obj.type === 'ui_part' && obj.part) {
    onUiPart?.(obj.part);
  } else if (obj.type === 'ui_patch' && obj.patch) {
    onUiPatch?.(obj.patch);
  } else if (obj.type === 'tool_call') {
    onToolCall?.(obj);
  } else if (obj.type === 'tool_result') {
    onToolResult?.(obj);
  } else if (obj.type === 'router_status' && obj.specialist) {
    onRouterStatus?.(obj.specialist);
  } else if (obj.type === 'done') {
    onDone?.(obj);
  } else if (obj.type === 'error') {
    onError?.(obj.detail);
    const err = new Error(obj.detail?.message || 'Stream error');
    err.fullError = obj.detail?.full_error;
    throw err;
  }
}
